import * as React from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { makeStyles, Menu, MenuItem } from '@material-ui/core'
import {
    mdiRestart,
    mdiBug,
    mdiPowerStandby,
    mdiBatterySyncOutline,
    mdiCogRefreshOutline,
    mdiTools
} from '@mdi/js'

import { Button } from '../../root/components/common'
import { useSelector } from 'react-redux'
import Icon from '@mdi/react'

const useStyles = makeStyles({
    iconUnderlay: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 50,
        width: 24,
        height: 24,
        marginRight: 8
    },
    listItem: {
        height: 50
    }
})

export const DeviceActions = ({
    isTom,
    isJerryLora,
    isTrapSensor,
    isJerryBaitRat,
    isTrapMe,
    isJerry3,
    label,
    onBtnPress,
    device,
    buttonStyles,
    className
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const { locale, theme } = useSelector(state => state.main)
    const isSetActiveTOMActionAvailable =
        isTom &&
        device.last_report_type &&
        ['2', '15', '16', '17', '18', '19'].includes(device.last_report_type)
    const open = Boolean(anchorEl)
    const classes = useStyles()
    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const ACTION_BUTTONS = [
        {
            label: locale.devices.reset,
            color: theme.primary,
            icon: mdiCogRefreshOutline,
            isHidden: () => isTrapSensor,
            actionName: 'reset_device'
        },
        {
            label: locale.devices.resetTomStatus,
            color: theme.warning,
            icon: mdiRestart,
            isHidden: () => !isSetActiveTOMActionAvailable,
            actionName: 'reset_tom_status'
        },
        {
            label: locale.devices.reportCatch,
            color: theme.error,
            icon: mdiBug,
            isHidden: () =>
                isTom || isJerry3 || isTrapSensor || isTrapMe || isJerryBaitRat,
            actionName: 'report_catch'
        },
        {
            label: locale.devices.setOffline,
            color: theme.warning,
            icon: mdiPowerStandby,
            isHidden: () => false,
            actionName: 'set_offline'
        },
        {
            label: locale.devices.resetBattery,
            color: theme.quaternary,
            icon: mdiBatterySyncOutline,
            isHidden: () =>
                isTom || isJerryLora || isTrapSensor || isJerryBaitRat,
            actionName: 'reset_battery'
        },
        {
            label: device.in_maintenance_mode
                ? locale.common.switchOffMMode
                : locale.common.switchOnMMode,
            color: theme.primary,
            icon: mdiTools,
            isHidden: () => false,
            actionName: 'set_maintenance_mode'
        }
    ]

    return (
        <div className={className}>
            <Button
                style={buttonStyles}
                id="actions-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                {label}
            </Button>
            <Menu
                elevation={2}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {ACTION_BUTTONS.map(i => {
                    if (i.isHidden()) {
                        return null
                    }
                    return (
                        <MenuItem
                            key={i.label}
                            classes={{
                                root: classes.listItem
                            }}
                            onClick={() => {
                                onBtnPress(i.actionName)
                                handleClose()
                            }}
                        >
                            <div
                                className={classes.iconUnderlay}
                                style={{ backgroundColor: i.color }}
                            >
                                <Icon
                                    path={i.icon}
                                    size={
                                        i.actionName === 'set_maintenance_mode'
                                            ? '16px'
                                            : '20px'
                                    }
                                    color="#FFF"
                                />
                            </div>
                            {i.label}
                        </MenuItem>
                    )
                })}
            </Menu>
        </div>
    )
}
